<template>
  <div class="label">
    <slot></slot>
    {{trunked}}
  </div>
</template>

<script>
export default {
  name: "ResponsiveLabel",
  props: {
    text: String,
    size: {
      type: Number,
      default: 20
    }
  },
  computed: {
    trunked: function() {
      return this.text.substring(0, Math.min(this.text.length, this.size));
    }
  }
};
</script>

<style scoped>
.label {
  font-size: 3vw;
}
</style>
